'use strict';

(function(app) {
    var initializedComponents = [],
        notInitializedComponents = [];

    app.init = function() {
        if(app && 'components' in app && app.hasOwnProperty('components')) {
            for(var component in app.components) {
                if('init' in app.components[ component ]) {
                    initializedComponents.push(component);

                    app.components[ component ].init();
                }
                else {
                    notInitializedComponents.push(component);
                }
            }
        }

        if(app.preferences.debug) {
            console.info('Initialized components', initializedComponents);
            console.info('Not initialized components', notInitializedComponents);
        }
    };
}(window.app = window.app || {}));

// Then init
app.init();
